import { render, staticRenderFns } from "./CoursewareToolbarClipboard.vue?vue&type=template&id=7f515856&"
import script from "./CoursewareToolbarClipboard.vue?vue&type=script&lang=js&"
export * from "./CoursewareToolbarClipboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports